export default {
  en: {
    fetchError: 'Failed fetching client notes.',
    fetchRetry: 'Retry',
    emptyNotePlaceholder: 'Leave a note...',
    emptyError: 'Notes cannot be empty.',
    add: 'Add note',
    addError: 'Failed to add note, please try again.',
    maxLengthError: 'Note is too long!',
    save: 'Save',
    saveError: 'Failed to save note, please try again.',
    cancel: 'Cancel',
    visibleLabel: 'Private notes are only visible to {0}.',
    pinTooltip: 'Pin note',
    unpinTooltip: 'Un-pin note',
    editTooltip: 'Edit note',
    pinFailed: 'Failed to pin note.',
    unpinFailed: 'Failed to un-pin note.',
    deleteTooltip: 'Delete note',
    deleteFailed: 'Failed to delete note.',
    emptyPlaceholder: 'No notes yet on this supplier, create one above.',
    deleteConfirmTitle: 'Are you sure you want to delete this note?',
    deleteConfirmDescription: 'This action cannot be undone.',
    trialPlaceholder: {
      title: 'Visualise and secure every link in your supply chain',
      description:
        'When you connect with suppliers on Risk Ledger, you unlock the power to visualise your entire supply chain network, identify concentration risks, and discover hidden dependencies.',
      title2: 'Key benefits',
      benefit1: 'Identify concentration risks where multiple suppliers share dependencies',
      benefit2: 'Pinpoint potential single points of failure in your supply chain',
      benefit3: "Discover hidden fourth-party connections you weren't aware of",
      benefit4: 'Make informed, data-driven decisions with visual risk insights',
      cta: 'Book a demo',
    },
  },
};
